import { Icon, Layout, Menu } from "antd";
import React, { useEffect, useState } from "react";
import { Route } from "react-router-dom";
import changePassword from "../containers/changePassword";
import logoImg from "../images/logoW.jpg";
import Footered from "./Footer";
import "./style.css";

const { Header, Sider, Content } = Layout;

const { SubMenu, Item } = Menu;

interface Props {
  history: any;
  page: any;
  logout: () => any;
  menu_item: any;
  match: any;
}

function getPopupContainer(triggerNode: any) {
  if (!triggerNode) {
    return;
  }
  return triggerNode.parentNode;
}

const Layouts = (props: Props): JSX.Element => {
  const [collapsed, setCollapsed] = useState(false);
  const [localname, setLocalName] = useState("");

  useEffect(() => {
    const nav = JSON.parse(sessionStorage.getItem("nav") || "{}");
    if (nav.userName !== "admin" && nav.password !== "12345678q") {
      props.history.push("/login");
    }
  }, []);

  const logout = () => {
    // props.history.push('/cahn');
    sessionStorage.clear();
  };

  const changPassword = () => {
    props.history.push("/changePassword");
  };

  const getUrl = (e: any) => {
    if (e.key === "home") {
      return props.history.push(`/`);
    }
    props.history.push(`/${e.key}`);
  };

  const menu_item = props.menu_item.map((item: any) => {
    if (item && item.MenuContent) {
      const { id, MenuIcon, title, MenuContent } = item;
      return (
        <SubMenu
          key={id}
          title={
            <span className="asideContent">
              {MenuIcon}
              <span className="asideTitle outer">{title}</span>
            </span>
          }
        >
          {MenuContent.map((imte2) => {
            return (
              <Menu.Item key={`${imte2.id}`}>
                <span className="asideContent">
                  <span className="asideTitle">{imte2.title}</span>
                </span>
              </Menu.Item>
            );
          })}
        </SubMenu>
      );
    } else if (item) {
      return (
        <Menu.Item key={item.id}>
          <div className="asideContent">
            {item.MenuIcon}
            <span className="asideTitle outer">{item.title}</span>
          </div>
        </Menu.Item>
      );
    } else {
      return;
    }
  });

  const page = props.page.map((item: any) => {

    if (location.pathname === "/" && item.id === "home") {
      return <Route key={item.id} path={"/"} component={item.dom} />;
    } else {
      return (
        <Route
          key={item.id}
          path={`/${item.id}`}
          component={item.dom}
        />
      );
    }
  });

  const url = location.pathname.split("/");
  const urled = `${url[1]}`;

  // let defaultId =
  //   location.pathname === "/" ? "home" : location.pathname.slice(1);
  let defaultId = location.pathname === "/" ? "home" : urled;

  useEffect(() => {
    const nav = JSON.parse(sessionStorage.getItem("nav") || "{}");
    setLocalName(nav.userName);
  }, []);

  return (
    <Layout className="layout admin_layouts">
      {/* <Layout> */}
        <Header className="layout_menu_header">
          <Menu
            className="wlayout__menus"
            mode="horizontal"
            theme="dark"
            defaultSelectedKeys={[defaultId]}
            selectedKeys={[defaultId]}
            // defaultOpenKeys={['jinjian', 'chaipiao', 'daikuan', 'user']}
            style={{ lineHeight: "64px" }}
            onClick={getUrl}
          >
            {menu_item}
            <SubMenu
              title={
                <span style={{ fontSize: "16px" }}>您好， {localname}</span>
              }
              className="wlmenu__settings"
            >
              <Item key="login" onClick={logout}>
                <Icon type="logout" />
                退出登陆
              </Item>
              <Item key="changPassword" onClick={changPassword}>
                <Icon type="redo" />
                修改密码
              </Item>
            </SubMenu>
          </Menu>
        </Header>
          <Content
            id="contentPage"
            style={
              {
                // margin: '24px 16px',
                // padding: 24,
                // background: '#fff',
                // minHeight: 280,
              }
            }
          >
            <Route exact path="/changePassword" component={changePassword} />
            {page}
          </Content>
        {/* <Footered /> */}
        {props.history.location.pathname === "/" ? <Footered /> : null}
      {/* </Layout> */}
    </Layout>
  );
};

export default Layouts;
